import { TrackerEventType } from "src/core/model/TrackerEventType";
import { TrackerVariableType } from "src/core/model/TrackerVariableType";

import { EventListener } from "./EventListener";
import { NativeEventTrigger } from "./PageViewListener";

/**
 * Listens for click events on the document.
 * Uses a cooldown to prevent excessive event triggering.
 * Mirrors Android TouchListener.
 */
export class ClickListener implements EventListener {
  private trigger: NativeEventTrigger;
  private started = false;
  private boundHandler: ((e: MouseEvent) => void) | null = null;
  private cooldownMs: number;
  private lastTriggerTs = 0;

  constructor(trigger: NativeEventTrigger, cooldownMs = 1000) {
    this.trigger = trigger;
    this.cooldownMs = cooldownMs;
  }

  start(): void {
    if (this.started) return;
    this.started = true;

    this.boundHandler = () => {
      const now = Date.now();
      if (now - this.lastTriggerTs >= this.cooldownMs) {
        this.lastTriggerTs = now;
        this.trigger(TrackerEventType.CLICK);
      }
    };
    document.addEventListener("click", this.boundHandler);
  }

  stop(): void {
    if (!this.started) return;
    this.started = false;

    if (this.boundHandler) {
      document.removeEventListener("click", this.boundHandler);
      this.boundHandler = null;
    }
  }

  getTypes(): TrackerEventType[] {
    return [TrackerEventType.CLICK];
  }

  getVariableTypes(): TrackerVariableType[] {
    return [TrackerVariableType.ELEMENT];
  }
}
